export default function(element, data, sendTrinityEvent) {
    sendTrinityEvent(data);
}
